import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-end",
  gap: "$sm"
});